export const DOMAINS = [
  {
    url: [
      "theme-astral-unique.com",
      "www.theme-astral-unique.com",
      "astro.fr.local",
    ],
    lang: "fr",
    googleAnalyticsId: "G-GFCLK6G8ZG",
    googleAdsId: "AW-10845657261",
    googleConversionId: "AW-17015062173/E-UXCOrD0rwaEJ39tLE_",
    // gtm: "GTM-TVFNRPMC",
  },
  {
    url: ["guida-astrale.com", "www.guida-astrale.com", "astro.it.local"],
    lang: "it",
    googleAnalyticsId: "G-GFCLK6G8ZG",
    googleAdsId: "AW-10845657261",
    googleConversionId: "AW-17015062173/E-UXCOrD0rwaEJ39tLE_",
    // gtm: "GTM-TVFNRPMC",
  },
];

export const currentDomain = () => {
  const host = window.location.hostname;
  const domain = DOMAINS.find((d) => d.url.includes(host));
  return domain;
};
